import { clsx } from "clsx";
import { useState } from "react";
import splash1280Avif from "../../../../public/images/splash/family-1280.avif";
import splash1280Jpg from "../../../../public/images/splash/family-1280.jpg";
import splash1600Avif from "../../../../public/images/splash/family-1600.avif";
import splash1600Jpg from "../../../../public/images/splash/family-1600.jpg";
import splash2000Avif from "../../../../public/images/splash/family-2000.avif";
import splash2000Jpg from "../../../../public/images/splash/family-2000.jpg";
import splash640Avif from "../../../../public/images/splash/family-640.avif";
import splash640Jpg from "../../../../public/images/splash/family-640.jpg";
import splash960Avif from "../../../../public/images/splash/family-960.avif";
import splash960Jpg from "../../../../public/images/splash/family-960.jpg";

const AVIF_SRC_SET = [
  `${splash640Avif} 640w`,
  `${splash960Avif} 960w`,
  `${splash1280Avif} 1280w`,
  `${splash1600Avif} 1600w`,
  `${splash2000Avif} 2000w`,
].join(", ");

const JPG_SRC_SET = [
  `${splash640Jpg} 640w`,
  `${splash960Jpg} 960w`,
  `${splash1280Jpg} 1280w`,
  `${splash1600Jpg} 1600w`,
  `${splash2000Jpg} 2000w`,
].join(", ");

/** The focus point of the image that stays in view despite cropping. */
const FOCAL_POINT = "36% 40%";

export type SplashImageProps = {
  media?: string;
  sizes: string;
  className?: string;
};

const SplashImage: React.FC<SplashImageProps> = ({
  media,
  sizes,
  className,
}) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <picture className="contents">
      <source
        type="image/avif"
        media={media}
        srcSet={AVIF_SRC_SET}
        sizes={sizes}
      />
      <source
        type="image/jpeg"
        media={media}
        srcSet={JPG_SRC_SET}
        sizes={sizes}
      />
      <img
        alt=""
        fetchPriority="high"
        onLoad={() => {
          setLoaded(true);
        }}
        className={clsx(
          "object-cover select-none pointer-events-none transition-opacity duration-200",
          loaded ? "opacity-100" : "opacity-0",
          className,
        )}
        style={{ objectPosition: FOCAL_POINT }}
      />
    </picture>
  );
};

export const BackgroundSplashImage: React.FC = () => (
  <SplashImage
    media="(width >= 40rem)"
    sizes="max(100vw, 178vh)"
    className="absolute inset-0 size-full max-sm:hidden"
  />
);

export const HeaderSplashImage: React.FC = () => (
  <SplashImage
    media="(width < 40rem)"
    sizes="100vw"
    className="w-full h-[calc(100svh-530px)] min-h-30 max-h-60 shrink-0 sm:hidden"
  />
);
